import React from 'react';
import ReactDOM from 'react-dom/client';
import { useLocation } from 'react-router-dom';
import App from './App';
import LandingPage from './LandingPage';
import reportWebVitals from './reportWebVitals';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

const allRouter = createBrowserRouter([
  {
    path: '/',
    element: <LandingPage />,
    children: [
      {
        path: "/",
      },
      {
        path: "/contact"
      },
      {
        path: "/terms"
      },
      {
        path: "/privacy"
      },
    ]
  },
  {
    path: '/*',
    element: <App />,
  },
]);

const getSubdomain = url => {
  let domain = url;
  if (url.includes("://")) {
      domain = url.split('://')[1];
  }
  const subdomain = domain.split('.')[0];
  if (domain === subdomain) {
    return null;
  }
  return subdomain;
};

function SubdomainHandler() {
  if (window.location.href.includes('toolover.vercel.app')) {
    return allRouter
  }
  const subdomain = getSubdomain(window.location.href);
  let router = createBrowserRouter([
    {
      path: '/*',
      element: <LandingPage />,
    }
  ]);
  if (subdomain) {
    router = createBrowserRouter([
      {
        path: '/*',
        element: <App />,
      },
    ]);
  }
  return router;
}

const appRouters = createBrowserRouter([
  {
    path: '/*',
    element: <App />,
  },
  {
    path: "/contact",
    element: <LandingPage />,
  },
  {
    path: "/terms",
    element: <LandingPage />,
  },
  {
    path: "/privacy",
    element: <LandingPage />,
  },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterProvider router={SubdomainHandler()} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
